import BaseError from '@whr/core_utils/baseError.js';
export var TenantUndefinedErrorCode;
(function (TenantUndefinedErrorCode) {
    TenantUndefinedErrorCode["TENANT_UNDEFINED"] = "TENANT_UNDEFINED";
})(TenantUndefinedErrorCode || (TenantUndefinedErrorCode = {}));
export class TenantUndefinedError extends BaseError {
    constructor(message, originalError) {
        super(TenantUndefinedErrorCode.TENANT_UNDEFINED, message, originalError, 500);
    }
}
//# sourceMappingURL=tenant_undefined_error.js.map